<template>

    <!-- <div class="form-popup" v-bind:class="isExpanded ? 'expanded' : ''">
        <div class="bike-icon"></div>
        <div class='content'>
            <h2 id="" style="margin-bottom:20px: color: #f37d5e" class="top-margin">News & Updates!</h2> 
            <div>Scratch the bike travel itch! Sign up for announcements and occasional content updates in your inbox.</div>
            <div id="mc_embed_signup">
            <form action="https://bikesleepbike.us7.list-manage.com/subscribe/post?u=c689107147db62a56a5c64fd4&amp;id=d755fae67a" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                <div id="mc_embed_signup_scroll">
                
                <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address" required>
                <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_c689107147db62a56a5c64fd4_d755fae67a" tabindex="-1" value=""></div>
                <div class="clear"><input type="submit" value="Get Updates!" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
                </div>
            </form>
        </div>
    </div> -->
    <div class="slide" v-bind:class="isExpanded ? 'expanded' : ''" style="z-index:10000000">
        <div class="bike-icon" @click="toggleSlider()"></div>
        <div class="close-icon" @click="toggleSlider()">
            <b-icon icon="times" size="is-small">
                
            </b-icon>
        </div>
        <div class='content' style="z-index:10000000">
                    <!-- <a>Link</a> -->
                    <p  style="margin-bottom:10px !important: margin-top: 30px; color: #f37d5e !important" class="is-size-5 title">Email Updates</p> 
                    <div class="is-size-7" style="line-height: 1.3em; margin-bottom:20px">Join the adventure! Get occasional project updates and selected new trip journals straight to your inbox.</div>
                    <!-- <pre>{{links}}</pre> -->
                    <div id="mc_embed_signup">
                    <form action="https://bikesleepbike.us7.list-manage.com/subscribe/post?u=c689107147db62a56a5c64fd4&amp;id=d755fae67a" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                        <div id="mc_embed_signup_scroll">
                        
                        <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address" required>
                        <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                        <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_c689107147db62a56a5c64fd4_d755fae67a" tabindex="-1" value=""></div>
                        <div class="clear"><input type="submit" value="Get updates!" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
                        </div>
                    </form>
                </div>
        </div>

    </div>
    <!-- </div> -->

    
</template>

<script>

export default {
  name: 'FormPopup',
  components: {},
  data () {
    return {
        isExpanded: false
    }
  },
  methods: {
     
      toggleSlider() {
          if (this.isExpanded) {
              this.$cookies.set("bsb_slider_closed", 1, 60*60*24*7);
          }
          this.isExpanded = !this.isExpanded;
      }
  },
  mounted() {
      
      if (!this.$cookies.get("bsb_slider_closed")) {
          var that = this;
          setTimeout(function() {
         that.isExpanded = true;
     }, 7000); 
      }
     

  }
  
}
</script>

<style scoped>
@media screen and (max-width: 1199px) { 
    .slide {
        display:none;
    }
}
    
@media screen and (min-width: 1200px) {

   .slide {
       position: fixed;
       bottom: -353px;
       
       right: 20px;
       background-color:#e8f9ff;
       width: 260px;
       height: 353px;
       border-radius: 10px 10px 0 0;
       padding: 30px;
       border: 3px solid #f37d5e;
       border-bottom: none;
       
       /* right: 10px;
       background-color: blue;
       width: 200px;
       height: 200px; */
   }
   .slide.expanded {
       bottom: 0px;
        -webkit-transition: bottom 1.5s ease-in-out;
     -moz-transition: bottom 1.5s ease-in-out;
        -o-transition: bottom 1.5s ease-in-out;
       transition: bottom 1.5s ease-in-out;
   }
   
   h2 {
       margin-top: 0;
       color: #f37d5e;
       font-size: 28px;
       font-weight: bold;
   }
  
   .slide .bike-icon {
       background-image:url(https://bikesleepbike.com/orange_bike_icon_bsb_left.png);
        height: 74px;
        width: 93px;
        position: absolute;
        background-size: contain;
        background-repeat: no-repeat;
        bottom: 100%;
        left: 200px;
         -webkit-transition: left 1.5s ease-in-out 0.3s;
     -moz-transition: left 1.5s ease-in-out 0.3s;
        -o-transition: left 1.5s ease-in-out 0.3s;
        transition: left 1.5s ease-in-out 0.3s;
        cursor: pointer;
   }
   .slide.expanded  .bike-icon {
       
       left: 100px;
       /* right: auto; */
   }
   .slide .close-icon {
       cursor:pointer;
       position: absolute;
       right: 10px;
       top: 5px;
   }
}

#mc_embed_signup input.email {
    font-size: 18px;
    text-align:center;
    padding: 8px 5px;
    height: auto;
    width: 100%;
    margin-bottom: 15px;
    margin-top: 15px;
    border: 1px solid #dbdbdb;
    border-radius: 5px;
}
#mc_embed_signup input.button {
    width: 100%;
    background-color: #f37d5e;
    font-size: 18px;
    height: auto;
    color: white;
}
#mc_embed_signup input.button:hover {
   background-color: #ff8239;
}

</style>


// WEBPACK FOOTER //
// src/components/FormPopup.vue